var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInhyeMainLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.729 184.002L226.126 149.791H216.314L192.445 184.002H202.25L221.167 156.712L240.049 184.002H249.729Z",
    fill: "#2E93EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.729 115.579L226.126 149.791H216.314L192.445 115.579H202.25L221.167 142.869L240.049 115.579H249.729Z",
    fill: "#E65722"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.477 183.871L71.8149 128.335L70.8788 115.579L124.407 175.713V183.871H121.477Z",
    fill: "#E65722"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M177.594 142.159H139.935V152.949H177.594V142.159Z",
    fill: "#2E93EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M177.594 146.896H139.935V157.422H177.594V146.896Z",
    fill: "#E65722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0972 115.579H28.2847V184.002H38.0972V115.579Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2306 115.584H4.94678V125.321H62.2306V115.584Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2306 174.265H4.94678V184.002H62.2306V174.265Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.313 149.788H226.126V184H216.313V149.788Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.313 115.574H226.126V149.785H216.313V115.574V115.574Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.111 115.579H255.298V184.002H265.111V115.579Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.018 115.579H255.298V125.316H294.018V115.579Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.018 174.265H255.298V184.002H294.018V174.265Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.935 115.579H130.123V184.002H139.935V115.579Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.527 115.579L71.4145 171.752L70.8921 184.002L123.429 124.969L122.901 115.579H121.527Z",
    fill: "#2E93EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.005 149.791L96.1765 143.996L101.337 149.791L96.1844 155.586L91.005 149.791Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3472 122.846V184.002H67.5347V115.579H70.8797",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.006 176.634V115.579H124.818V184.002H121.596",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.406 115.579H177.594V184.002H187.406V115.579Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.594 145.58H139.935V154.265H177.594V145.58Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M287.653 142.159H265.111V152.949H287.653V142.159Z",
    fill: "#2E93EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M287.653 146.896H265.111V157.422H287.653V146.896Z",
    fill: "#E65722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.653 145.58H265.111V154.265H287.653V145.58Z",
    fill: "#111111"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 357,
    height: 78,
    fill: "white",
    transform: "translate(-23 111)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 315.387,
    height: 112.667,
    fill: "white",
    transform: "translate(-7.6687 93.6667)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInhyeMainLogo);
export default __webpack_public_path__ + "static/media/inhye-main-logo.5fe79d83.svg";
export { ForwardRef as ReactComponent };